import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopProdLavoroFormService } from './scheda-coop-prod-lavoro-form.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [
    SchedaCoopProdLavoroFormService
  ]
})
export class SchedaCoopProdLavoroFormModule { }
